module.exports = __webpack_public_path__ + "img/logo (5).65b39a81.png";